"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Anania, Anushavan on 12/7/2016.
 */
require("rxjs/add/observable/combineLatest");
require("rxjs/add/operator/publishReplay");
var meta_category_1 = require("./meta-category");
var meta_category_id_1 = require("./meta-category-id");
var meta_field_id_1 = require("./meta-field-id");
var meta_group_id_1 = require("./meta-group-id");
var KbDeserializationHelper = /** @class */ (function () {
    function KbDeserializationHelper() {
    }
    KbDeserializationHelper.extractMainCategories = function (responseData) {
        var categories = responseData
            .map(this.extractCategory)
            .filter(function (item) { return item.getIsWithVersioning(); })
            .sort(KbDeserializationHelper.systemNameComparator);
        return new Set(categories);
    };
    KbDeserializationHelper.extractCategory = function (item) {
        var categorySystemName = item.metaCategoryId.systemName;
        var displayNameMsgId = item.displayName;
        var hasCustomCategory = item.hasCustomSorting;
        var isCacheable = item.isCacheable;
        var metaCategoryId = new meta_category_id_1.MetaCategoryId(categorySystemName);
        var wfProcessId = item.wfProcessId;
        var hasIcon = item.hasIcon ? item.hasIcon : false;
        var isWithVersioning = item.isWithVersioning ?
            item.isWithVersioning : false;
        var isClassifier = item.isClassifier ? item.isClassifier :
            false;
        var nameMetaFieldIds = item.nameMetaFieldIds.map(function (metaFieldIdJson) {
            return KbDeserializationHelper.extractMetaFieldId(metaFieldIdJson);
        });
        var keyMetaFieldIds = item.keyMetaFieldIds.map(function (metaFieldIdJson) {
            return KbDeserializationHelper.extractMetaFieldId(metaFieldIdJson);
        });
        var actionDataMetaFieldIds = item.actionDataMetaFieldIds
            ?
                item.actionDataMetaFieldIds.map(function (metaFieldIdJson) {
                    return KbDeserializationHelper.extractMetaFieldId(metaFieldIdJson);
                })
            : [];
        return new meta_category_1.MetaCategory(metaCategoryId, displayNameMsgId, hasCustomCategory, hasIcon, '', wfProcessId, isCacheable, nameMetaFieldIds, isWithVersioning, isClassifier, keyMetaFieldIds, actionDataMetaFieldIds);
    };
    KbDeserializationHelper.extractMetaFieldId = function (metaFieldIdJson) {
        var name = metaFieldIdJson.systemName;
        var categorySystemName = metaFieldIdJson.metaCategoryId.systemName;
        var groupSystemName = metaFieldIdJson.groupId != null ?
            metaFieldIdJson.groupId.systemName :
            null;
        return new meta_field_id_1.MetaFieldId(new meta_category_id_1.MetaCategoryId(categorySystemName), name, new meta_group_id_1.MetaGroupId(groupSystemName));
    };
    KbDeserializationHelper.systemNameComparator = function (item1, item2) {
        var systemName1 = item1.metaCategoryId.systemName.toLowerCase();
        var systemName2 = item2.metaCategoryId.systemName.toLowerCase();
        return systemName1 < systemName2 ? -1 :
            systemName1 > systemName2 ? 1 : 0;
    };
    return KbDeserializationHelper;
}());
exports.KbDeserializationHelper = KbDeserializationHelper;
//# sourceMappingURL=kb-deserialization-helper.js.map